<script setup lang="ts">
import celebrate from '@/assets/images/blog/celebrate.svg'
import { ref } from 'vue'
import axios from 'axios'
import { useField } from 'vee-validate'
import * as yup from 'yup'

const error = ref<string>('')
const status = ref<number | null>(null)
const {
  value: email,
  errorMessage: emailError,
  validate: validateEmail
} = useField(
  'email',
  yup.string().required('Email is required').email('Email must be a valid email')
)

/**
 * subscribe
 */
const subscribe = async () => {
  const isValid = await validateEmail()

  if (!isValid || emailError.value) {
    return
  }

  status.value = null
  error.value = ''

  await axios
    .post('/api/doodle/newsletterSubscribe', {
      email: email.value
    })
    .then((res) => {
      status.value = res.status
    })
    .catch((err) => {
      error.value = err.response.data.message
    })
}
</script>
<template>
  <section
    class="flex flex-col justify-between bg-[#FDF4EC] px-5 py-14 md:px-11 md:py-12 xl:flex-row xl:items-center xl:px-44 xl:py-28 dark:bg-[#292929]"
  >
    <div class="md:w-[71%] xl:w-96">
      <h4 class="text-[32px] font-semibold dark:text-[#D8DBDF]">Get Your Dose of JDoodle Joy!</h4>
      <p class="mt-6 font-light xl:mt-5 dark:text-[#D8DBDF]">
        Subscribe for JDoodle surprises, creative coding insights, fun facts, and tips.
      </p>
    </div>
    <div class="mt-6 md:w-[71%] xl:mt-0 xl:w-[calc(100%-32.25rem)]" v-if="!status">
      <div class="flex flex-col md:flex-row">
        <input
          v-model="email"
          class="w-full rounded-lg py-4 pl-8 pr-4 outline-none placeholder:text-base placeholder:text-[#C4C2C2] md:w-2/3 md:rounded-l-lg md:rounded-r-none md:placeholder:text-lg xl:py-5 dark:bg-[#121212]"
          placeholder="Enter email address"
          type="text"
        />
        <button
          @click="subscribe"
          class="mt-4 w-full rounded-lg bg-text-brand py-4 text-base font-semibold text-white md:mt-0 md:w-1/3 md:rounded-l-none md:rounded-r-lg md:text-lg xl:py-5 xl:text-xl"
        >
          Subscribe
        </button>
      </div>
      <p class="error mt-1 text-xs">{{ emailError }}</p>
      <p class="error mt-1 text-xs">{{ error }}</p>
      <p class="mt-3 text-sm font-light xl:mt-2.5 dark:text-[#D8DBDF]">
        Your Privacy Matters! JDoodle uses your email address specifically for sending our
        promotional emails and updates. Read our Privacy Policy
        <router-link class="underline" to="/privacy">here</router-link> .
      </p>
    </div>
    <div class="mt-6 flex items-center gap-x-5" v-else>
      <img class="w-12 md:w-20" :src="celebrate" alt="celebrate icon" />
      <p class="text-xl font-medium text-text-brand md:text-2xl">Thanks for Subscribing!</p>
    </div>
  </section>
</template>
